export default {
	head() {
		return {
			title: `Promotions - ${this.$config.DOMAIN?.includes('www')
				? this.$config.DOMAIN?.split('.')[1]
				: this.$config.DOMAIN?.split('.')[0]
				}`,
			meta: [
				{
					hid: 'og:title',
					name: 'og:title',
					content: `Promotions - ${this.$config.DOMAIN?.includes('www')
						? this.$config.DOMAIN?.split('.')[1]
						: this.$config.DOMAIN?.split('.')[0]
						}`, // This can be overridden by page-level meta tags.
				},
			],
		}
	},
	methods: {
		goToPromotionDetail(item) {
			const locale = this.handleCookie('wl_locale')
			if (!locale || !item) return
			const navigationKey = item.display_name[`${locale}-slug`]
			if (navigationKey) {
				this.navigateRoute(item, navigationKey)
				return
			}

			// Fallback to the first key that ends with '-slug'
			const firstNavigationSlugKey = Object.keys(
				item.display_name || {}
			).find((slug) => slug?.endsWith('-slug'))
			if (firstNavigationSlugKey) {
				this.navigateRoute(
					item,
					item.display_name[firstNavigationSlugKey]
				)
			}
		},
		navigateRoute(item, path) {
			const encodedPath = encodeURIComponent(path)

			this.$store.dispatch('themes/promotion/setPromotion', item)

			this.$router.push({ path: `/promotion/${encodedPath}` })
		},
	}
}